"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_MACHINE = exports.IMPORT_MACHINE = exports.PHONE_SCREEN_SWITCH_MACHINE = exports.PHONE_SCREEN_MACHINE = exports.CONTACT_MACHINE = exports.OPEN_CONTACT_STATUSES = exports.MANAGER_RESPONSE_MACHINE = exports.REVIEW_MACHINE = exports.ATTENDANCE_MACHINE = exports.ASSESSMENT_ATTEMPT_MACHINE = exports.POSITION_MACHINE = exports.EXAM_SESSION_MACHINE = exports.OFFER_MACHINE = exports.INTERVIEW_MACHINE = exports.JOB_OPENING_MACHINE = exports.REQUISITION_MACHINE = exports.SKIP_STAGE_ROLES = exports.APPLICATION_MACHINE = void 0;
exports.transitionsFrom = transitionsFrom;
exports.findTransition = findTransition;
exports.canTransition = canTransition;
exports.acceptsReason = acceptsReason;
exports.transitionRequiresReason = transitionRequiresReason;
function build(machine) {
    return machine;
}
/** Appendix A — the keystone. `interview_N -> interview_N+1` is expanded explicitly. */
exports.APPLICATION_MACHINE = build({
    name: 'application',
    initial: 'new',
    terminal: ['joined', 'rejected', 'withdrawn', 'closed_job', 'transferred', 'auto_rejected'],
    transitions: [
        { from: 'new', to: 'screening', who: ['recruiter', 'system'], note: 'System on knockout pass (L6).' },
        { from: 'new', to: 'auto_rejected', who: ['system'], note: 'Knockout fail; rescuable at SCR-04 (L8).' },
        { from: 'auto_rejected', to: 'screening', who: ['recruiter'], note: 'Rescue path (L8).' },
        { from: 'screening', to: 'assessment', who: ['recruiter'] },
        { from: 'screening', to: 'interview_1', who: ['recruiter'], note: 'Direct when the job has no test.' },
        { from: 'screening', to: 'rejected', who: ['recruiter'], requiresReason: true },
        { from: 'assessment', to: 'interview_1', who: ['recruiter', 'system'], note: 'Auto only per L6.' },
        { from: 'assessment', to: 'rejected', who: ['recruiter'], requiresReason: true },
        { from: 'interview_1', to: 'interview_2', who: ['recruiter', 'hiring_manager'], note: 'Requires a StageDecision.' },
        { from: 'interview_2', to: 'interview_3', who: ['recruiter', 'hiring_manager'], note: 'Requires a StageDecision.' },
        { from: 'interview_1', to: 'rejected', who: ['recruiter', 'hiring_manager'], requiresReason: true },
        { from: 'interview_2', to: 'rejected', who: ['recruiter', 'hiring_manager'], requiresReason: true },
        { from: 'interview_3', to: 'rejected', who: ['recruiter', 'hiring_manager'], requiresReason: true },
        { from: 'interview_1', to: 'hold', who: ['recruiter', 'hiring_manager'], note: 'Silver medalist.' },
        { from: 'interview_2', to: 'hold', who: ['recruiter', 'hiring_manager'], note: 'Silver medalist.' },
        { from: 'interview_3', to: 'hold', who: ['recruiter', 'hiring_manager'], note: 'Silver medalist.' },
        { from: 'interview_1', to: 'offer', who: ['hiring_manager', 'hr_lead'] },
        { from: 'interview_2', to: 'offer', who: ['hiring_manager', 'hr_lead'] },
        { from: 'interview_3', to: 'offer', who: ['hiring_manager', 'hr_lead'] },
        { from: 'assessment', to: 'offer', who: ['hiring_manager', 'hr_lead'], note: 'Select on a passed test, when the job has no interview round (ADR 0045).' },
        // C4-a (ADR 0077): a job with no test and no round selects from Contact; the service checks the job has neither.
        { from: 'screening', to: 'offer', who: ['hiring_manager', 'hr_lead'], note: 'Select from Contact, when the job has no test and no interview round (C4-a).' },
        { from: 'hold', to: 'offer', who: ['recruiter'], note: 'On slot release (L18).' },
        { from: 'hold', to: 'rejected', who: ['recruiter'], requiresReason: true, note: 'Pooled on job close (L18).' },
        { from: 'offer', to: 'hired_pending_join', who: ['system'], note: 'Offer accepted.' },
        { from: 'offer', to: 'rejected', who: ['recruiter'], requiresReason: true },
        // S23 Q6: an offer withdrawn after the candidate saw it; GEN-OFFER-WITHDRAWN, no letter.
        { from: 'hired_pending_join', to: 'rejected', who: ['hr_lead'], requiresReason: true, onlyReasonCodes: ['GEN-OFFER-WITHDRAWN'], note: 'An accepted offer withdrawn by the company.' },
        // S23: a declined offer carries its §L20 reason; an expired one WD-NORESPONSE (System).
        { from: 'offer', to: 'withdrawn', who: ['candidate', 'recruiter', 'system'], requiresReason: true, note: 'Offer declined or expired. NOT a rejection.' },
        // S22 undo, and S23 Q6: an offer withdrawn before it was sent returns them where they came from.
        { from: 'offer', to: 'interview_1', who: ['recruiter', 'hiring_manager', 'hr_lead'], note: 'Selection undone, or the offer withdrawn before sending.' },
        { from: 'offer', to: 'interview_2', who: ['recruiter', 'hiring_manager', 'hr_lead'], note: 'Selection undone, or the offer withdrawn before sending.' },
        { from: 'offer', to: 'interview_3', who: ['recruiter', 'hiring_manager', 'hr_lead'], note: 'Selection undone, or the offer withdrawn before sending.' },
        { from: 'offer', to: 'assessment', who: ['recruiter', 'hiring_manager', 'hr_lead'], note: 'Selection undone, or the offer withdrawn before sending.' },
        { from: 'offer', to: 'screening', who: ['recruiter', 'hiring_manager', 'hr_lead'], note: 'A selection from Contact undone (C4-a); they return to Contact as they were.' },
        { from: 'offer', to: 'hold', who: ['recruiter', 'hiring_manager', 'hr_lead'], note: 'A release to offer undone, or its offer withdrawn before sending.' },
        { from: 'hired_pending_join', to: 'joined', who: ['recruiter'], note: 'Creates Employee, fills Position.' },
        // S23 Q5: the "Didn't join" button — WD-NORESPONSE here, `accepted_no_show` on the offer.
        { from: 'hired_pending_join', to: 'withdrawn', who: ['recruiter'], requiresReason: true, note: 'accepted_no_show releases holds.' },
        // "any active -> withdrawn / transferred / closed_job" is expanded by the helper below.
    ],
});
/** Appendix A: "any active" transitions, applied to every non-terminal stage. */
const ANY_ACTIVE_APPLICATION_TRANSITIONS = [
    { to: 'withdrawn', who: ['candidate', 'recruiter'], requiresReason: true, note: 'Reason captured; NOT a rejection.' },
    { to: 'transferred', who: ['recruiter'], note: 'Creates a NEW linked application on the other job.' },
    { to: 'closed_job', who: ['hr_lead'], requiresReason: true, note: 'Triggers L13.' },
    {
        to: 'rejected',
        who: ['recruiter', 'hr_lead'],
        requiresReason: true,
        onlyReasonCodes: ['GEN-DUPLICATE', 'GEN-FILLED'],
        note: 'Inside a candidate merge (DECISIONS-LOG S14 Q9), or a filled job closed out (S24 Q5).',
    },
];
/** L23 transition permissions: only an HR Lead may skip a stage, and it is logged. */
exports.SKIP_STAGE_ROLES = ['hr_lead'];
/** §L25 Requisition. Time-to-fill starts at `approved`. */
exports.REQUISITION_MACHINE = build({
    name: 'requisition',
    initial: 'draft',
    terminal: ['filled', 'cancelled'],
    transitions: [
        { from: 'draft', to: 'submitted', who: ['owner'], note: 'Required fields complete.' },
        // The owner withdraws a draft without a reason; an HR Lead cancelling someone
        // else's gives one (the service asks for it — §L25 "any active -> cancelled").
        { from: 'draft', to: 'cancelled', who: ['owner', 'hr_lead'] },
        { from: 'submitted', to: 'in_approval', who: ['system'], note: 'An approval chain exists.' },
        { from: 'submitted', to: 'approved', who: ['system'], note: 'No approval chain configured.' },
        { from: 'in_approval', to: 'approved', who: ['approver'], note: 'All steps approved.' },
        { from: 'in_approval', to: 'rejected', who: ['approver'], requiresReason: true },
        { from: 'in_approval', to: 'draft', who: ['approver'], requiresReason: true, note: 'Send back with a comment.' },
        { from: 'approved', to: 'converted', who: ['recruiter'], note: 'Job Opening created.' },
        { from: 'approved', to: 'on_hold', who: ['hr_lead', 'hiring_manager'], requiresReason: true, pausesSla: true },
        { from: 'converted', to: 'on_hold', who: ['hr_lead', 'hiring_manager'], requiresReason: true, pausesSla: true },
        { from: 'on_hold', to: 'approved', who: ['hr_lead', 'hiring_manager'], resumesSla: true },
        { from: 'on_hold', to: 'converted', who: ['hr_lead', 'hiring_manager'], resumesSla: true },
        { from: 'converted', to: 'filled', who: ['system'], note: 'All slots filled.' },
        { from: 'converted', to: 'partially_filled', who: ['recruiter'], note: 'Job closed with slots remaining.' },
        { from: 'rejected', to: 'draft', who: ['owner'], note: 'Revision; creates version N+1.' },
        { from: 'filled', to: 'reopened', who: ['hr_lead'], note: 'Does not reset the original time-to-fill.' },
        { from: 'cancelled', to: 'reopened', who: ['hr_lead'], note: 'Does not reset the original time-to-fill.' },
        { from: 'reopened', to: 'converted', who: ['recruiter'] },
        // §L25 "any active -> cancelled | HR Lead | reason mandatory; triggers L13".
        // `draft` is above, because the owner may also withdraw their own.
        ...['submitted', 'in_approval', 'approved', 'converted', 'on_hold', 'reopened'].map((from) => ({
            from,
            to: 'cancelled',
            who: ['hr_lead'],
            requiresReason: true,
            note: 'Triggers L13 when candidates are active.',
        })),
    ],
});
/** §L25 Job opening. */
exports.JOB_OPENING_MACHINE = build({
    name: 'job_opening',
    initial: 'draft',
    terminal: ['filled', 'cancelled'],
    transitions: [
        // HR Lead added 2026-09-29 (DECISIONS-LOG S12 Q9) so §L25 agrees with F5.12.
        { from: 'draft', to: 'open', who: ['recruiter', 'hr_lead'], note: 'Passes the JOB-09 validation checklist.' },
        { from: 'open', to: 'on_hold', who: ['recruiter', 'hr_lead'], requiresReason: true, pausesSla: true, note: 'Postings unpublished.' },
        { from: 'on_hold', to: 'open', who: ['recruiter', 'hr_lead'], resumesSla: true },
        { from: 'open', to: 'filled', who: ['system'], note: 'All slots filled and all hires joined.' },
        { from: 'open', to: 'closed_partial', who: ['hr_lead'], note: 'Returns remaining slots to the Position ledger.' },
        { from: 'open', to: 'cancelled', who: ['hr_lead'], requiresReason: true, note: 'Triggers L13.' },
        // D89 (§L13, F4.09): a cancelled requisition cancels its job, even one not yet open or on hold.
        { from: 'draft', to: 'cancelled', who: ['system'], requiresReason: true, note: 'Its requisition was cancelled (L13).' },
        { from: 'on_hold', to: 'cancelled', who: ['system'], requiresReason: true, note: 'Its requisition was cancelled (L13).' },
        { from: 'filled', to: 'reopened', who: ['hr_lead'], note: 'e.g. a new hire did not join.' },
        { from: 'closed_partial', to: 'reopened', who: ['hr_lead'] },
        { from: 'reopened', to: 'open', who: ['recruiter', 'hr_lead'] },
    ],
});
/** §L25 Interview. Panelist substitution never changes the state. */
exports.INTERVIEW_MACHINE = build({
    name: 'interview',
    initial: 'unscheduled',
    terminal: ['completed', 'cancelled', 'candidate_no_show', 'panelist_no_show'],
    transitions: [
        { from: 'unscheduled', to: 'slots_offered', who: ['recruiter'], note: 'Candidate self-booking path.' },
        { from: 'unscheduled', to: 'scheduled', who: ['recruiter'] },
        { from: 'slots_offered', to: 'scheduled', who: ['recruiter', 'candidate'] },
        { from: 'scheduled', to: 'confirmed', who: ['candidate', 'system'], note: 'Auto-confirm at T-24h.' },
        // The recruiter records who asked; neither candidate nor panelist moves it (S19 Q4, Q10).
        { from: 'scheduled', to: 'rescheduled', who: ['recruiter'], note: 'Candidate-initiated pauses SLA (L7).' },
        { from: 'confirmed', to: 'rescheduled', who: ['recruiter'], note: 'Candidate-initiated pauses SLA (L7).' },
        // S19 fills the gaps §L25 left (the rows marked "added S19"): `rescheduled` means the
        // old time is released and a new one is being arranged; the candidate never moves it
        // themselves (S19 Q4), and sending new times retires the earlier link.
        { from: 'rescheduled', to: 'scheduled', who: ['recruiter'], resumesSla: true },
        { from: 'rescheduled', to: 'slots_offered', who: ['recruiter'] },
        { from: 'slots_offered', to: 'slots_offered', who: ['recruiter'], note: 'New times sent.' },
        { from: 'unscheduled', to: 'cancelled', who: ['recruiter'], requiresReason: true },
        { from: 'slots_offered', to: 'cancelled', who: ['recruiter'], requiresReason: true },
        { from: 'rescheduled', to: 'cancelled', who: ['recruiter'], requiresReason: true },
        { from: 'scheduled', to: 'completed', who: ['recruiter', 'panelist'], note: 'Opens the scorecard deadline clock.' },
        { from: 'confirmed', to: 'completed', who: ['recruiter', 'panelist'], note: 'Opens the scorecard deadline clock.' },
        { from: 'scheduled', to: 'candidate_no_show', who: ['recruiter'] },
        { from: 'confirmed', to: 'candidate_no_show', who: ['recruiter'] },
        { from: 'scheduled', to: 'panelist_no_show', who: ['recruiter'], note: 'Appears on RPT-04.' },
        { from: 'confirmed', to: 'panelist_no_show', who: ['recruiter'], note: 'Appears on RPT-04.' },
        { from: 'scheduled', to: 'cancelled', who: ['recruiter'], requiresReason: true },
        { from: 'confirmed', to: 'cancelled', who: ['recruiter'], requiresReason: true },
    ],
});
/** §L25 Offer. Time-to-fill stops at `accepted`; time-to-slot runs `accepted` -> `joined`. */
exports.OFFER_MACHINE = build({
    name: 'offer',
    initial: 'draft',
    terminal: ['joined', 'declined', 'expired', 'accepted_no_show', 'withdrawn_by_company'],
    transitions: [
        { from: 'draft', to: 'in_approval', who: ['recruiter'], note: 'Out-of-band salary adds an approval step.' },
        { from: 'in_approval', to: 'approved', who: ['approver'] },
        { from: 'in_approval', to: 'rejected', who: ['approver'], requiresReason: true, note: 'Returns to draft.' },
        { from: 'rejected', to: 'draft', who: ['recruiter'] },
        { from: 'approved', to: 'sent', who: ['recruiter'], note: 'PDF generated and locked to this version.' },
        { from: 'sent', to: 'viewed', who: ['system'], note: 'Candidate opens it in the portal.' },
        { from: 'sent', to: 'negotiating', who: ['recruiter'], note: 'Creates version N+1; re-approval if band-crossing.' },
        { from: 'viewed', to: 'negotiating', who: ['recruiter'], note: 'Creates version N+1; re-approval if band-crossing.' },
        { from: 'negotiating', to: 'sent', who: ['recruiter'] },
        { from: 'sent', to: 'accepted', who: ['candidate', 'recruiter'], note: 'Records timestamp, IP, PDF version.' },
        { from: 'viewed', to: 'accepted', who: ['candidate', 'recruiter'], note: 'Records timestamp, IP, PDF version.' },
        { from: 'sent', to: 'declined', who: ['candidate', 'recruiter'], requiresReason: true, note: 'Triggers L18.' },
        { from: 'viewed', to: 'declined', who: ['candidate', 'recruiter'], requiresReason: true, note: 'Triggers L18.' },
        { from: 'sent', to: 'expired', who: ['system'], note: 'Validity date passed; triggers L18.' },
        { from: 'viewed', to: 'expired', who: ['system'], note: 'Validity date passed; triggers L18.' },
        { from: 'accepted', to: 'joined', who: ['recruiter'], note: 'Creates Employee, fills Position.' },
        { from: 'accepted', to: 'accepted_no_show', who: ['recruiter'], note: 'Triggers L18.' },
        // S23 (DECISIONS-LOG S23 Q4, Q6): §L12 binds an approval to its figures, so editing an
        // approved offer before sending takes it back to draft; version N+1 outside the band goes
        // back to approval; and the HR Lead may withdraw at any point before joining.
        { from: 'approved', to: 'draft', who: ['recruiter'], note: 'An approved figure changed before sending (§L12).' },
        { from: 'negotiating', to: 'in_approval', who: ['recruiter'], note: 'Version N+1 is outside the band.' },
        ...['draft', 'in_approval', 'rejected', 'approved', 'sent', 'viewed', 'negotiating', 'accepted'].map((from) => ({
            from,
            to: 'withdrawn_by_company',
            who: ['hr_lead'],
            requiresReason: true,
            note: 'Requires written justification.',
        })),
    ],
});
/**
 * §L25 Exam session. `recruiter` covers the HR Lead (§L23 gives both the object), and
 * `invigilator` means the person named on the session, whatever their role — a recruiter
 * often supervises their own exam (S18 Q7). A move passes through `rescheduled` and
 * straight back to `scheduled` in one step, so the list reopens and re-locks at the new
 * T-24h (ADR 0020).
 */
exports.EXAM_SESSION_MACHINE = build({
    name: 'exam_session',
    initial: 'draft',
    terminal: ['completed', 'cancelled'],
    transitions: [
        { from: 'draft', to: 'scheduled', who: ['recruiter', 'hr_lead'], note: 'Venue, invigilator and datetime set.' },
        { from: 'scheduled', to: 'roster_locked', who: ['recruiter', 'hr_lead', 'system'], note: 'T-24h, auto or manual; never auto at short notice (S18 Q9).' },
        { from: 'roster_locked', to: 'in_progress', who: ['invigilator', 'recruiter', 'hr_lead'] },
        { from: 'in_progress', to: 'results_entry', who: ['invigilator', 'recruiter', 'hr_lead'], note: 'Everyone on the list marked.' },
        { from: 'results_entry', to: 'completed', who: ['recruiter', 'hr_lead'], note: 'All attendees have a result.' },
        { from: 'draft', to: 'cancelled', who: ['recruiter', 'hr_lead'], requiresReason: true },
        { from: 'scheduled', to: 'cancelled', who: ['recruiter', 'hr_lead'], requiresReason: true, note: 'Notifies all candidates.' },
        { from: 'roster_locked', to: 'cancelled', who: ['recruiter', 'hr_lead'], requiresReason: true, note: 'Notifies all candidates.' },
        { from: 'scheduled', to: 'rescheduled', who: ['recruiter', 'hr_lead'] },
        { from: 'roster_locked', to: 'rescheduled', who: ['recruiter', 'hr_lead'] },
        { from: 'rescheduled', to: 'scheduled', who: ['recruiter', 'hr_lead'] },
    ],
});
/**
 * Position — S5 build notes and E1, which is where the states come from; §L25 has
 * no table for this object because S1 predates the corrected status list (ADR 0007).
 *
 * There is no `archived` state on purpose. Archiving is orthogonal to status: an
 * archived seat keeps whatever status it held, which is what lets a historical
 * report still say "this was filled when it was retired". It is a timestamp on the
 * row, not a place in this machine.
 *
 * `becoming_vacant` is fed by employee-exit events in S24 (E20 inbound), so `system`
 * is the only actor on the way in. Nothing writes it before then.
 */
exports.POSITION_MACHINE = build({
    name: 'position',
    initial: 'vacant',
    // A seat is never finished — archiving retires it without ending its history.
    terminal: [],
    transitions: [
        { from: 'planned', to: 'vacant', who: ['hr_lead'], note: 'Budget approved; the seat becomes real.' },
        { from: 'vacant', to: 'planned', who: ['hr_lead'], note: 'F3.05 — future need, not yet approved.' },
        { from: 'vacant', to: 'in_recruitment', who: ['hr_lead', 'system'], note: 'System when S9 approves a requisition against it.' },
        { from: 'in_recruitment', to: 'vacant', who: ['hr_lead', 'system'], note: 'System when the requisition is cancelled or closed unfilled.' },
        { from: 'in_recruitment', to: 'filled', who: ['hr_lead', 'system'], note: 'System on hire conversion (S24), or when recruiting stops with no place open (D63).' },
        { from: 'vacant', to: 'filled', who: ['hr_lead'], note: 'A seat filled outside the system — a transfer, or backdated data entry.' },
        { from: 'filled', to: 'becoming_vacant', who: ['system'], note: 'E20 exit announced; turns vacant on the last working day.' },
        // D63 (2026-11-02): a replacement is hired for a seat someone still sits in. Its places
        // stay taken (no open place), so the seat goes back to filled if it ends without a hire.
        { from: 'filled', to: 'in_recruitment', who: ['system'], note: 'System when a replacement (or additional-hire) request on it is approved.' },
        { from: 'becoming_vacant', to: 'vacant', who: ['hr_lead', 'system'], note: 'The last working day passed.' },
        { from: 'becoming_vacant', to: 'filled', who: ['hr_lead', 'system'], note: 'The resignation was withdrawn.' },
        { from: 'filled', to: 'vacant', who: ['hr_lead'], note: 'Left without notice, or a correction.' },
        // L7: a budget freeze pauses every SLA clock linked to the seat, and needs a
        // written reason. The hook is wired in S9; the flag is set here.
        { from: 'planned', to: 'frozen', who: ['hr_lead'], requiresReason: true, pausesSla: true },
        { from: 'vacant', to: 'frozen', who: ['hr_lead'], requiresReason: true, pausesSla: true },
        { from: 'in_recruitment', to: 'frozen', who: ['hr_lead'], requiresReason: true, pausesSla: true },
        { from: 'filled', to: 'frozen', who: ['hr_lead'], requiresReason: true, pausesSla: true },
        // Unfreezing returns the seat to whatever it was doing, which the row remembers
        // in `previous_status` exactly as a requisition's `on_hold` does (§L25).
        { from: 'frozen', to: 'planned', who: ['hr_lead'], resumesSla: true },
        { from: 'frozen', to: 'vacant', who: ['hr_lead'], resumesSla: true },
        { from: 'frozen', to: 'in_recruitment', who: ['hr_lead'], resumesSla: true },
        { from: 'frozen', to: 'filled', who: ['hr_lead'], resumesSla: true },
    ],
});
/**
 * One online test sitting (S17, ADR 0019). §L25 has no table for it; this follows E7
 * ("sent / started / submitted / expired / graded") and the S17 planning decisions.
 * `submitted` is where an attempt waits for a person to mark its written answers (S18);
 * one the system marked in full goes straight on to `auto_graded`. A seat at an exam
 * session (S18) is an attempt with no link, and the only one that can be `abandoned`.
 */
exports.ASSESSMENT_ATTEMPT_MACHINE = build({
    name: 'assessment_attempt',
    initial: 'not_started',
    terminal: ['auto_graded', 'manually_graded', 'expired', 'cancelled'],
    transitions: [
        { from: 'not_started', to: 'in_progress', who: ['candidate'], note: 'Opened the link and began.' },
        { from: 'not_started', to: 'expired', who: ['system'], note: 'The link passed its expiry unopened (N-22).' },
        { from: 'not_started', to: 'cancelled', who: ['recruiter', 'hr_lead', 'system'], note: 'Withdrawn — e.g. the move that sent it was undone.' },
        { from: 'in_progress', to: 'cancelled', who: ['recruiter', 'hr_lead', 'system'] },
        { from: 'in_progress', to: 'submitted', who: ['candidate', 'system'], note: "System when the last section's time runs out." },
        { from: 'submitted', to: 'auto_graded', who: ['system'], note: 'Every answer marked by the system (F9.05).' },
        { from: 'submitted', to: 'manually_graded', who: ['recruiter', 'hr_lead'], note: 'The assigned grader marked the rest (F9.07, S18).' },
        // S18 — a seat at an exam session is an attempt with no link: booked (`not_started`),
        // then a result typed in, or a no-show, or withdrawn (removed, moved, cancelled).
        { from: 'not_started', to: 'manually_graded', who: ['invigilator', 'recruiter', 'hr_lead'], note: 'On paper: the total entered (F9.12).' },
        { from: 'not_started', to: 'abandoned', who: ['invigilator', 'recruiter', 'hr_lead'], note: 'On paper: marked absent — a no-show, never a fail (E7).' },
    ],
});
/**
 * §L25 "per-candidate attendance within a session": `registered → present → completed`,
 * or `→ absent`, or `→ rescheduled`. While the exam runs, a mis-tap between present,
 * absent and asked-to-move can be corrected (ADR 0020); a result makes it `completed`.
 */
exports.ATTENDANCE_MACHINE = build({
    name: 'session_attendance',
    initial: 'registered',
    terminal: ['completed'],
    transitions: [
        { from: 'registered', to: 'present', who: ['invigilator', 'recruiter', 'hr_lead'] },
        { from: 'registered', to: 'absent', who: ['invigilator', 'recruiter', 'hr_lead'], note: 'A no-show (ASM-NOSHOW), not a fail.' },
        { from: 'registered', to: 'rescheduled', who: ['invigilator', 'recruiter', 'hr_lead'] },
        { from: 'present', to: 'absent', who: ['invigilator', 'recruiter', 'hr_lead'], note: 'A correction, while the exam runs.' },
        { from: 'present', to: 'rescheduled', who: ['invigilator', 'recruiter', 'hr_lead'], note: 'A correction, while the exam runs.' },
        { from: 'absent', to: 'present', who: ['invigilator', 'recruiter', 'hr_lead'], note: 'A correction, while the exam runs.' },
        { from: 'absent', to: 'rescheduled', who: ['invigilator', 'recruiter', 'hr_lead'], note: 'A correction, while the exam runs.' },
        { from: 'rescheduled', to: 'present', who: ['invigilator', 'recruiter', 'hr_lead'], note: 'A correction, while the exam runs.' },
        { from: 'rescheduled', to: 'absent', who: ['invigilator', 'recruiter', 'hr_lead'], note: 'A correction, while the exam runs.' },
        { from: 'present', to: 'completed', who: ['invigilator', 'recruiter', 'hr_lead'], note: 'Their result was entered (F9.12).' },
    ],
});
/**
 * §L25 Review status, §L31: HR's review inside `screening` (R2, ADR 0037). Entering
 * `screening` starts it at `to_review` (`withReviewEntry`). Rejecting isn't a move here:
 * the application machine's `screening → rejected` carries the §L19 reason.
 */
exports.REVIEW_MACHINE = build({
    name: 'review_status',
    initial: 'to_review',
    terminal: [],
    transitions: [
        { from: 'to_review', to: 'shortlisted', who: ['recruiter', 'hr_lead'] },
        { from: 'to_review', to: 'maybe', who: ['recruiter', 'hr_lead'] },
        { from: 'maybe', to: 'shortlisted', who: ['recruiter', 'hr_lead'] },
        { from: 'shortlisted', to: 'to_review', who: ['recruiter', 'hr_lead'], note: 'Undo (S15), only while not yet sent.' },
        // DECISIONS-LOG "Start R6" Q5: Undo on H, and a change of mind before sending.
        { from: 'maybe', to: 'to_review', who: ['recruiter', 'hr_lead'], note: 'Undo (S15).' },
        { from: 'shortlisted', to: 'maybe', who: ['recruiter', 'hr_lead'], note: 'Only while not yet sent.' },
    ],
});
/**
 * §L25 Manager response, §L31. `owner` is the job's Requested by or Line manager, who
 * aren't a role (§L23 "Shortlist answer"). After Done, only HR (a recruiter or the HR
 * Lead) changes an answer, and only the HR Lead answers for a manager before Done
 * (DECISIONS-LOG "Start R6" Q6): `canAnswerShortlist` in `shortlist.ts` applies that.
 */
exports.MANAGER_RESPONSE_MACHINE = build({
    name: 'manager_response',
    initial: 'not_sent',
    terminal: ['hr_proceeded'],
    transitions: [
        { from: 'not_sent', to: 'awaiting', who: ['system'], note: 'Included in a shortlist send (F24.01).' },
        { from: 'awaiting', to: 'yes', who: ['owner', 'hr_lead'] },
        { from: 'awaiting', to: 'no', who: ['owner', 'hr_lead'], requiresReason: true, note: 'A short reason; a §L19 code is optional.' },
        { from: 'yes', to: 'no', who: ['owner', 'hr_lead', 'recruiter'], requiresReason: true, note: 'Until Done; after Done, HR only.' },
        { from: 'no', to: 'yes', who: ['owner', 'hr_lead', 'recruiter'], note: 'Until Done; after Done, HR only.' },
        { from: 'awaiting', to: 'hr_proceeded', who: ['recruiter', 'hr_lead'], note: '"Move to contact" without the manager\'s answer (O30).' },
        { from: 'not_sent', to: 'hr_proceeded', who: ['recruiter', 'hr_lead'], note: '"Move to contact" with "Shortlist to the line manager" switched off: nothing is sent (ADR 0082).' },
    ],
});
/** §L25 Contact status: the four statuses a call or an email can still change. */
exports.OPEN_CONTACT_STATUSES = ['not_contacted', 'emailed', 'no_answer', 'reached'];
/**
 * §L25 Contact status, §L32. Reaching Contact, or moving on to a new step, starts it
 * afresh at `not_contacted` (System): a restart, not a move. A call that ends where it
 * began (another no answer) changes no status; it only counts an attempt.
 */
exports.CONTACT_MACHINE = build({
    name: 'contact_status',
    initial: 'not_contacted',
    terminal: ['not_interested', 'no_response', 'not_coming'],
    transitions: [
        { from: 'not_contacted', to: 'emailed', who: ['system'], note: 'A template invite is sent.' },
        { from: 'no_answer', to: 'emailed', who: ['system'], note: 'A template invite is sent.' },
        ...exports.OPEN_CONTACT_STATUSES.flatMap((from) => ['no_answer', 'reached']
            .filter((to) => to !== from)
            .map((to) => ({ from, to, who: ['recruiter', 'hr_lead'], note: 'A call is logged.' }))),
        // Owner, 2026-11-01: "Send to the next step" in Contact confirms and sends in one click, so a person not yet reached may be confirmed too.
        ...['not_contacted', 'emailed', 'reached', 'no_answer'].map((from) => ({ from, to: 'confirmed', who: ['recruiter', 'hr_lead'], note: 'Agreed to the next step.' })),
        ...exports.OPEN_CONTACT_STATUSES.map((from) => ({ from, to: 'not_interested', who: ['recruiter', 'hr_lead'], requiresReason: true, note: 'Records a withdrawal (§L20).' })),
        ...exports.OPEN_CONTACT_STATUSES.map((from) => ({ from, to: 'no_response', who: ['recruiter', 'hr_lead'], note: 'Suggested after 3 attempts, or 2 working days with no reply.' })),
        { from: 'confirmed', to: 'not_coming', who: ['recruiter', 'hr_lead'], requiresReason: true, note: 'Records a withdrawal (§L20).' },
    ],
});
exports.PHONE_SCREEN_MACHINE = build({
    name: 'phone_screen',
    initial: 'in_screening',
    terminal: [],
    transitions: [
        { from: 'in_screening', to: 'sent_to_contact', who: ['recruiter', 'hr_lead'], note: 'Ticked and sent to Contact, at any round.' },
        { from: 'sent_to_contact', to: 'in_screening', who: ['recruiter', 'hr_lead'], note: 'Undo, only while still Not contacted.' },
        { from: 'in_screening', to: 'out', who: ['recruiter', 'hr_lead'], requiresReason: true, onlyReasonCodes: ['SCR-PHONE'], note: 'A rejection; the note names the screening.' },
        { from: 'out', to: 'in_screening', who: ['recruiter', 'hr_lead'], note: 'Undo of the rejection, while the regret email is unsent.' },
    ],
});
/** §L25 Phone screening, per job: off by default; switched off only when nobody is waiting in it. */
exports.PHONE_SCREEN_SWITCH_MACHINE = build({
    name: 'phone_screen_switch',
    initial: 'off',
    terminal: [],
    transitions: [
        { from: 'off', to: 'on', who: ['recruiter', 'hr_lead'], note: 'From the Shortlist. Everyone at Contact still Not contacted comes in.' },
        { from: 'on', to: 'off', who: ['recruiter', 'hr_lead'], note: 'Only when nobody is waiting in the step: send them to Contact or screen them out first.' },
    ],
});
/**
 * §L25 Import (§L29, R4). `owner` is whoever started it; the system finishes it. Nothing
 * comes back from `discarded` or `cancelled`: a new upload is a new import.
 */
exports.IMPORT_MACHINE = build({
    name: 'import',
    initial: 'uploaded',
    terminal: ['done', 'done_with_problems', 'cancelled', 'discarded'],
    transitions: [
        { from: 'uploaded', to: 'mapped', who: ['recruiter', 'hr_lead', 'system'], note: 'Name plus email or phone matched; a saved matching may apply itself.' },
        { from: 'mapped', to: 'importing', who: ['recruiter', 'hr_lead'], note: 'Preview seen.' },
        { from: 'importing', to: 'done', who: ['system'], note: 'Every row processed, no row or CV problems.' },
        { from: 'importing', to: 'done_with_problems', who: ['system'], note: 'Every row processed; at least one needs a person.' },
        { from: 'importing', to: 'cancelled', who: ['recruiter', 'hr_lead'], note: 'Rows already processed stay.' },
        { from: 'uploaded', to: 'discarded', who: ['recruiter', 'hr_lead'], note: 'Nothing was imported.' },
        { from: 'mapped', to: 'discarded', who: ['recruiter', 'hr_lead'], note: 'Nothing was imported.' },
    ],
});
/**
 * §L25 User status (Admin redesign 2026-11-02). `owner` is the invited person accepting their
 * invite. Suspend moves nothing and is undone by Unsuspend; deactivate hands the work over first.
 * Reactivating somebody who never accepted their invite sends them back to `invited`.
 */
exports.USER_MACHINE = build({
    name: 'user',
    initial: 'invited',
    terminal: [],
    transitions: [
        { from: 'invited', to: 'active', who: ['owner'], note: 'Accepts the invite and sets a password.' },
        { from: 'invited', to: 'deactivated', who: ['admin'], note: 'Deactivated, or their invite cancelled.' },
        { from: 'active', to: 'suspended', who: ['admin'], note: 'Blocks sign-in and ends their sessions; moves nothing. Not on yourself.' },
        { from: 'suspended', to: 'active', who: ['admin'], note: 'Unsuspend.' },
        { from: 'active', to: 'deactivated', who: ['admin'], note: 'Their work is handed over first. Not on yourself.' },
        { from: 'suspended', to: 'deactivated', who: ['admin'], note: 'Their work is handed over first.' },
        { from: 'deactivated', to: 'active', who: ['admin'], note: 'Reactivate, when they had accepted their invite.' },
        { from: 'deactivated', to: 'invited', who: ['admin'], note: 'Reactivate, when they never accepted: a fresh invite goes out.' },
    ],
});
// --- Evaluation helpers ----------------------------------------------------
/** Every transition out of `from`, including the application "any active" set. */
function transitionsFrom(machine, from) {
    const listed = machine.transitions.filter((t) => t.from === from);
    if (machine.name !== 'application')
        return listed;
    const stage = from;
    if (machine.terminal.includes(from))
        return listed;
    // A move the stage already lists (screening → rejected) keeps its own, wider rule.
    const anyActive = ANY_ACTIVE_APPLICATION_TRANSITIONS.filter((t) => t.to !== stage && !listed.some((own) => own.to === t.to)).map((t) => ({ ...t, from }));
    return [...listed, ...anyActive];
}
function findTransition(machine, from, to) {
    return transitionsFrom(machine, from).find((t) => t.to === to);
}
/**
 * The single question every service asks before a state change. An unlisted
 * transition is not "unusual" — it does not exist.
 */
function canTransition(machine, from, to, role) {
    const transition = findTransition(machine, from, to);
    if (!transition)
        return false;
    // An HR Lead may skip stages and override, always with a reason and always logged (§L23).
    if (role === 'hr_lead' && machine.name === 'application')
        return true;
    return transition.who.includes(role);
}
/** Whether this transition accepts this reason code — a narrowed move accepts only its own. */
function acceptsReason(machine, from, to, reasonCode) {
    const transition = findTransition(machine, from, to);
    if (!transition)
        return false;
    return transition.onlyReasonCodes === undefined || transition.onlyReasonCodes.includes(reasonCode);
}
/** Non-negotiable #2 in general form: does this transition need a reason first? */
function transitionRequiresReason(machine, from, to) {
    return findTransition(machine, from, to)?.requiresReason === true;
}
//# sourceMappingURL=state-machines.js.map